<template>
<div class="contents_855">
  <div>
    <router-link v-show="isStaffTypeManager" :to="{name:'staff-progress-management'}">
      進捗管理
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManagerOrLeader" :to="{name:'staff-users'}">
      ユーザー一覧
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManagerOrLeader" :to="{name:'staff-onetime-users'}">
      単発ユーザー一覧
    </router-link>
  </div>
  <div>
    <router-link :to="{name:'staff-wash-requests'}">
      集配一覧
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManagerOrLeader" :to="{name:'staff-business-holiday-setting'}">
      休業日管理
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManager" :to="{name:'staff-manual-payments'}">
      手動決済管理
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManager" :to="{name:'staff-maintenance'}">
    メンテナンス
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManagerOrLeader" :to="{name:'staff-operation-histories'}">
      操作履歴
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManager" :to="{name:'staff-area-infos'}">
      提供エリア
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManager" :to="{name:'staff-onetime-payments'}">
      単発料金管理
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManagerOrLeader" :to="{name:'staff-members'}">
      運営アカウント管理
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManager" :to="{name:'staff-vehicles'}">
      車両情報
    </router-link>
  </div>
  <div>
    <router-link v-show="isStaffTypeManager" :to="{name:'staff-dispatch-reservations'}">
      配車予約
    </router-link>
  </div>
  <div>
  <a href="#" @click="logout">
      ログアウト
    </a>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { useAdminPageAccess } from '@/composables/useAdminPageAccess'
import { AdminPageType } from '@/consts/admin'
export default {
  name: 'staff-top',
  computed: {
    ...mapGetters('user', [
      'isLoggedIn',
      'isStaffTypeManager',
      'isStaffTypeManagerOrLeader',
    ]),
  },
  async mounted() {
    await this.$store.dispatch('user/getMe')
    const { ensureManagerAccessInMaintenance } = useAdminPageAccess(AdminPageType.STAFF)
    if (!await ensureManagerAccessInMaintenance()) return
  },
   methods: {
    logout() {
      this.$store.dispatch('user/logout')
        .then(() => {
          this.$store.dispatch('localStorage/set', {
            key: 'serverToken',
            val: null,
          })
          location.href = '/login'
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
